import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant qui réinitialise le scroll en haut de la page
 * à chaque changement de route
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Cible le conteneur avec overflow-y-auto
    const scrollContainer = document.querySelector('.flex-1.overflow-y-auto');
    if (scrollContainer) {
      scrollContainer.scrollTop = 0;
    }
    // Fallback pour window au cas où
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
